import { rgba, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const preview: ThemedFunctor = ({ theme }) => css`
  position: relative;
  max-height: calc(10 * 1.375rem);
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 4.5rem;
    pointer-events: none;

    background: linear-gradient(
      to bottom,
      ${rgba(theme.color.background.neutral.default.highest, 0)} 0%,
      ${theme.color.background.neutral.default.lowest} 100%
    );
  }
`;

export const annotationListItem: ThemedFunctor = ({ theme }) => css`
  padding-bottom: ${theme.remSize[75]};

  &:last-child {
    padding-bottom: 0;
  }
`;

export const fileSection: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[150]};
  padding-bottom: ${theme.remSize[200]};
  border-bottom: 1px solid ${theme.palettes.neutrals.light};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const actionWrapper: ThemedFunctor = () => css`
  align-self: flex-start;
`;
